<template>
    <div>
        <h5-dialog
            title="实名认证"
            :show-close-button="showCloseButton"
            :show-login-out-button="showLoginOutButton"
            @close="$emit('close')"
            @close-bind-id-modal="$emit('close-bind-id-modal')"
        >
            <div class="form">
                <div class="m-b-lg text-left" style="font-size: 13px;">
                    <!-- <div>
                        <i class="fa fa-warning m-r-sm" style="color: #ee0a24"></i>
                        <span>亲爱的用户：</span>
                    </div> -->
                    <div>
                        <!-- 依据国家新闻出版署发布的有关通知，游戏用户必须完成实名后方可进入游戏，体验游戏服务，请您尽快完成实名验证。 -->
                        根据文化部《网络游戏管理暂行办法》要求，网络游戏用户需进行实名认证，请先进行实名认证后再进入游戏。
                    </div>
                    <div style="color:red;font-size:12px;">
                        实名信息提交后不可修改，请谨慎填写！
                    </div>
                    <!-- <br/>
                    <div>
                        <i class="fa fa-bullhorn" style="color: #ee0a24"></i>
                        完成实名到游戏内公众号领取豪华礼包。
                    </div> -->
                </div>
                <div class="form-item">
                    <h5-input v-model="bindForm.real_name" placeholder="请输入真实姓名">
                        <template v-slot:prepend>
                            <i class="fa fa-user-o" style="font-size:16px;color:#f9dda0;" />
                        </template>
                    </h5-input>
                </div>
                <div class="form-item">
                    <h5-input v-model="bindForm.identity_card" placeholder="请输入身份证号码">
                        <template v-slot:prepend>
                            <i class="fa fa-shield" style="font-size:16px;color:#f9dda0;" />
                        </template>
                    </h5-input>
                </div>
                <!-- <div class="text-center">
                    <button class="btn btn-text btn-primary" @click="showJuveniles = true" style="text-decoration:underline;">关于防止未成年人沉迷措施</button>
                </div> -->
            </div>
            <template v-slot:footer>
                <button class="btn btn-block btn-primary" @click="startBindID">
                    提交认证
                </button>
            </template>
        </h5-dialog>
        <Juveniles v-if="showJuveniles" @agree="handleAgree"></Juveniles>
    </div>
</template>

<script>
import H5Dialog from '@/components/H5Dialog'
import H5Input from '@/components/H5Input'
import { certificate } from '@/service'

export default {
    name: 'BindIdCard',
    components: { 
        H5Input, 
        H5Dialog,
        Juveniles: () => import('../components/Juveniles'), 
    },
    data() {
        return {
            bindForm: {
                real_name: '',
                identity_card: '',
            },
            showJuveniles: false,
        }
    },
    props: {
        closable: { default: true, type: Boolean },
        loginOutable: { default: false, type: Boolean },
    },
    computed: {
        showCloseButton() {
            if (!this.closable) {
                return false
            } else {
                return this.$route.name !== 'BindIdCard'
            }
        },
        showLoginOutButton() {
            if (!this.loginOutable) {
                return false
            } else {
                return this.$route.name !== 'BindIdCard'
            }
        },
    },
    methods: {
        startBindID() {
            // 校验
            if (!this.bindForm.real_name) {
                this.$toast('请输入真实姓名')
                return
            }
            if (!this.bindForm.identity_card) {
                this.$toast('请输入身份证号码')
                return
            }
            this.$toast.loading('正在进行身份认证')
            certificate(this.bindForm).then(res => {
                if (Number(res.code) === 0) {
                    this.$store.dispatch('updateVerifyInfo', {
                        ...res.data,
                        is_verified: true
                    })
                    this.$toast.success({
                        message: '认证成功',
                        onClose: () => {
                            if(res.data.anti === 4 && res.data.anti_time === 0){
                                this.$dialog.alert({
                                    title: '提示',
                                    message: `${res.data.anti_msg}`,
                                    beforeClose: (action, done) => {
                                        this.$emit('close-bind-id-modal')
                                        done()
                                    },
                                    confirmButtonText: '确定',
                                })
                            }else{
                                this.$emit('bind-success')
                            }
                        },
                    })
                } else {
                    this.$toast(res.msg || '认证失败')
                }
            })
        },
        handleAgree() {
            this.showJuveniles = false
        },
    }
}
</script>

<style scoped>

</style>
